import React from "react";

type ErrorAlertProps = {
  message: string;
  onDismiss?: () => void;
  className?: string;
};

const ErrorAlert: React.FC<ErrorAlertProps> = ({
  message,
  onDismiss,
  className = "",
}) => {
  return (
    <div
      role="alert"
      className={`flex items-start justify-between gap-4 rounded-md border border-red-100 bg-red-100 px-6 py-4 text-red-900 shadow-sm ${className}`.trim()}
    >
      <p className="text-base">{message}</p>
      {onDismiss && (
        <button
          type="button"
          aria-label="Dismiss error"
          className="shrink-0 text-black transition-colors hover:text-gray-900"
          onClick={onDismiss}
        >
          <span className="icon-close text-xl text-black" aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

export default ErrorAlert;
